export default __webpack_public_path__ + "static/do-position-e17da35f39961975c3897b4e1a033386.png";